import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './clubs.action';

@Injectable({ providedIn: 'root' })
export class ClubsTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                id: '', 
                club_name: '', 
                club_categories_name: null,
                phone_number: '',
                members_count: '',
                city: '',
                is_active: '1',
            };

    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'club_name';
    initialSortDirection = 'asc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    categories = [];
    statuses = [
        {"id": "1", "name": "COMMON.active"},
        {"id": "2", "name": "COMMON.inactive"},
        {"id": "3", "name": "CLUB.archive"},
    ];
    columns = [
                { prop: 'id', name: 'CLUB.club-id', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'club_name', name: 'CLUB.club-name', sortable: true, hasFilter: true, filter: "input", widthSet: 240},
                { prop: 'city', name: 'CLUB.city', sortable: true, hasFilter: true, filter: "input", widthSet: 170},
                // { prop: 'email_address', name: 'CLUB.club-email', sortable: true, hasFilter: true, filter: "input", widthSet: 280},
                { prop: 'phone_number', name: 'CLUB.phone-number', sortable: true, hasFilter: true, filter: "input", widthSet: 170},
                { prop: 'members_count', name: 'CLUB.total-debtors', sortable: true, hasFilter: false, filter: "input"},
                { prop: 'club_categories_name', name: 'CLUB.category', sortable: true, hasFilter: true, filter: "select", options: 'categories', options_id: "id", options_label: "name"},
                { prop: 'is_active', name: 'COMMON.status', sortable: true, hasFilter: true, filter: "select", options: 'statuses', options_id: "id", options_label: "name"},
                // { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: ""},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){

        if(
            // (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            Object.entries(this.filters).some(([key, value]) => {
                if (key === 'is_active'){
                    return value !== '1';
                }

                return value !== '' && value !== null;
            }) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            id: "",
            club_name: "",
            club_categories_name: null,
            phone_number: "",
            members_count: "",
            city: "",
            is_active: "1"
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}